import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import accountReducer from './slices/accountSlice';
import aiSystemsReducer from './slices/aiSystemsSlice';
import authReducer from './slices/authSlice';
import counterReducer from './slices/counterSlice';
import dashboardReducer from './slices/dashboardSlice';
import documentationReducer from './slices/documentationSlice';
import fileUploadReducer from './slices/fileUploadSlice';
import reportReducer from './slices/reportSlice';
import repositoryReducer from './slices/repositorySlice';
import requirementStepsReducer from './slices/requirementStepsSlice';
import stepperReducer from './slices/stepperSlice';
import summaryReducer from './slices/summarySlice';
import systemLoggingReducer from './slices/systemLoggingSlice';
import deployerControlMonitoringReducer from './slices/deployerControlMonitoringSlice';
import tutorialGuideReducer from './slices/tutorialGuideSlice';
import userManagementReducer from './slices/userManagementSlice';
import accountDefaultReducer from './slices/accountDefaultSlice';
import notificationReducer from './slices/notificationSlice';
import toastReducer from './slices/toastSlice';
import sidePanelReducer from './slices/sidePanelSlice';
import aiPoweredReducer from './slices/aiPoweredSlice';
import appStatusReducer from './slices/appStatusSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth']
};

const rootReducer = combineReducers({
  counter: counterReducer,
  auth: authReducer,
  fileUpload: fileUploadReducer,
  tutorialGuide: tutorialGuideReducer,
  stepper: stepperReducer,
  account: accountReducer,
  aiSystems: aiSystemsReducer,
  dashboard: dashboardReducer,
  report: reportReducer,
  summary: summaryReducer,
  userManagement: userManagementReducer,
  documentation: documentationReducer,
  systemLogging: systemLoggingReducer,
  deployerControlMonitoring: deployerControlMonitoringReducer,
  repository: repositoryReducer,
  requirementSteps: requirementStepsReducer,
  accountDefault: accountDefaultReducer,
  notification: notificationReducer,
  toast: toastReducer,
  sidePanel: sidePanelReducer,
  aiPowered: aiPoweredReducer,
  appStatus: appStatusReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    })
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
